"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.invitationType = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reduxAct = require("redux-act");

var _ramda = require("ramda");

var _constants = require("../../../constants");

var actions = _interopRequireWildcard(require("./invitationType.actions"));

var _invitationType2 = require("./invitationType.types");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var initialState = {
  isLoading: false,
  isLoaded: false,
  isSaving: false,
  isSaved: false,
  availableInvitationTypes: [],
  selectedInvitationType: null,
  errors: {},
  state: _constants.stepState.DISABLED
};
exports.initialState = initialState;
var invitationType = (0, _reduxAct.createReducer)({}, initialState).on(actions.editInvitationType, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    state: _constants.stepState.ACTIVE,
    isSaved: false
  });
}).on(actions.resetInvitationType, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    state: _constants.stepState.ACTIVE,
    isSaved: false,
    selectedInvitationType: state.availableInvitationTypes.find(function (type) {
      return type.id === _invitationType2.VirtualGiftInvitationMethod.email;
    }) || null
  });
}).on(actions.initInvitationType, function (state, payload) {
  var isSaved = payload.isSaved,
      selectedInvitationType = payload.selectedInvitationType;
  return _objectSpread(_objectSpread({}, state), {}, {
    isSaved,
    selectedInvitationType,
    state: isSaved ? _constants.stepState.PASSED : _constants.stepState.ACTIVE
  });
}).on(actions.getInvitationTypes, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: true,
    isLoaded: false
  });
}).on(actions.getInvitationTypesSuccess, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: true,
    availableInvitationTypes: payload,
    errors: {},
    selectedInvitationType: state.selectedInvitationType && payload.find(function (type) {
      var _state$selectedInvita;

      return type.id === ((_state$selectedInvita = state.selectedInvitationType) === null || _state$selectedInvita === void 0 ? void 0 : _state$selectedInvita.id);
    }) || null
  });
}).on(actions.getInvitationTypesFail, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: false
  });
}).on(actions.saveInvitationType, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isSaving: true,
    isSaved: false,
    errors: {}
  });
}).on(actions.saveInvitationTypeSuccess, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isSaving: false,
    isSaved: true,
    selectedInvitationType: payload,
    state: _constants.stepState.PASSED
  });
}).on(actions.saveInvitationTypeFail, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isSaving: false,
    isSaved: false,
    errors: payload
  });
}).on(actions.selectInvitationTypeId, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    errors: {},
    selectedInvitationType: state.availableInvitationTypes.find(function (type) {
      return type.id === payload;
    }) || null
  });
}).on(actions.clearError, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    errors: (0, _ramda.set)((0, _ramda.lensPath)(payload), null, state.errors)
  });
}).on(actions.clearErrors, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    errors: {}
  });
});
exports.invitationType = invitationType;